import { useState } from 'react';
import { useProperty, useSnowplowTracking, useTranslation } from '@eti/providers';
import { ConnectedComboBox } from '@eti/form';
import { constants, persistInputData } from '@eti/utils';
import { cx } from '@eti/styles';
import { TRAVEL_DOCUMENT_ISSUING_COUNTRY } from '../../utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const getCountryOptions = countries => countries.map(country => ({
  code: country.code,
  label: country.label,
  value: String(country.id)
}));
const TravelDocumentIssuingCountry = _ref => {
  let {
    className,
    countries,
    form,
    id,
    labelRef
  } = _ref;
  const {
    p
  } = useProperty();
  const {
    t
  } = useTranslation();
  const {
    isSnowplowTrackingEnabled,
    sendTrackEvent
  } = useSnowplowTracking();
  const [nationalityHasChanged, setNationalityHasChanged] = useState(false);
  const handleOnChange = option => {
    if (p('IbeClient.TravelerDetails.PersistFormData.Enabled')) {
      persistInputData(form, `traveler-${id}-${TRAVEL_DOCUMENT_ISSUING_COUNTRY}`)(option);
    }
    if (isSnowplowTrackingEnabled && !nationalityHasChanged) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Click',
        label: 'Nationality',
        property: option.label,
        value: parseInt(id, 10) + 1
      });
      setNationalityHasChanged(true);
    }
  };
  return /*#__PURE__*/_jsx(ConnectedComboBox, {
    className: cx(className, MOUSE_FLOW_CLASS_NAMES),
    "data-testid": `travelerDetails-TravelDocumentIssueCountry-${id}-dropdown`,
    label: t('TravelerForm.TravelDocumentIssueCountry.Label'),
    labelRef: labelRef,
    name: TRAVEL_DOCUMENT_ISSUING_COUNTRY,
    onChange: handleOnChange,
    options: getCountryOptions(countries),
    placeholder: t('TravelerForm.TravelDocumentIssueCountry.Placeholder'),
    shouldMarkInputAsRequired: true,
    validationRuleName: TRAVEL_DOCUMENT_ISSUING_COUNTRY
  });
};
export default TravelDocumentIssuingCountry;